export const REGION_COLORS: Record<string, string> = {
  Americas: '#7C5CFC',
  Europe: '#10B981',
  Asia: '#F97316',
  'Middle East': '#EAB308',
  Africa: '#EC4899',
  Oceania: '#3B82F6',
};
